export default __webpack_public_path__ + "946a21ae06197fdbbc3b465316bffa92.png";